import { EditOutlined } from '@ant-design/icons';
import { type RootState } from '@reducers';
import { ColorPicker, Form, Input, Row, Space } from 'antd';
import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '../../hooks/use-app-dispatch';
import { tagsAdd } from '../../reducers/tags/reducer';
import { SPACING } from '../../theme/tokens';

interface IForm {
  name: string;
  color: string;
}

const randomHex = `#${Math.floor(Math.random() * 16777215).toString(16)}`;

function TagAdd(): React.ReactElement {
  const dispatch = useAppDispatch();
  const tagsInProcess = useSelector((s: RootState) => s.Tags.inProcess);

  const [defaultColor] = useState(randomHex);

  const onFinish = useCallback(
    ({ name, color }: IForm): void => {
      dispatch(tagsAdd(name, color));
    },
    [dispatch],
  );

  const [form] = Form.useForm<IForm>();

  return (
    <Form
      initialValues={{ name: '', color: defaultColor }}
      form={form}
      onFinish={(values: IForm): void => onFinish(values)}
    >
      <Row gutter={[SPACING.none, SPACING.xl]}>
        <Space align="start">
          <Form.Item
            name="name"
            rules={[
              {
                required: true,
              },
              {
                type: 'string',
                min: 3,
              },
            ]}
          >
            <Input
              size="large"
              placeholder="Create new product with name"
              prefix={<EditOutlined />}
              type="string"
              disabled={tagsInProcess}
            />
          </Form.Item>

          <Form.Item
            name="color"
            rules={[
              {
                required: true,
              },
              {
                type: 'string',
                min: 3,
              },
            ]}
          >
            <Input type="hidden" />
          </Form.Item>

          <ColorPicker
            defaultValue={defaultColor}
            size="large"
            onChange={(_value, hex: string): void =>
              form.setFieldValue('color', hex)
            }
          />
        </Space>
      </Row>
    </Form>
  );
}

export default TagAdd;
